import React, { useState } from 'react';

function TooltipInfo({ texto }) {
  const [visivel, setVisivel] = useState(false);

  return (
    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
      <span
        onClick={() => setVisivel(!visivel)}
        title={texto}
        style={{
          cursor: 'pointer',
          color: '#6b7280',
          fontSize: 13,
          lineHeight: 1,
          userSelect: 'none',
          flexShrink: 0,
        }}
      >
        ℹ️
      </span>

      {visivel && (
        <>
          <div
            onClick={() => setVisivel(false)}
            style={{ position: 'fixed', inset: 0, zIndex: 99 }}
          />
          <div style={{
            position: 'absolute',
            top: 'calc(100% + 8px)',
            left: 0,
            zIndex: 100,
            background: '#1e293b',
            color: '#f1f5f9',
            padding: '10px 14px',
            borderRadius: 8,
            width: 'min(230px, calc(100vw - 32px))',
            fontSize: 12,
            lineHeight: 1.6,
            boxShadow: '0 4px 24px rgba(0,0,0,0.35)',
            whiteSpace: 'pre-line',
          }}>
            {texto}
          </div>
        </>
      )}
    </div>
  );
}

export default TooltipInfo;
